// Frontend/src/components/admin/ui/ConfirmDialog.js

const ConfirmDialog = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'Confirm Action',
  message = 'Are you sure you want to perform this action?',
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  processing = false,
  confirmColor = 'primary'
}) => {
  if (!isOpen) return null;

  const buttonClasses = {
    primary: 'btn-primary',
    danger: 'btn-error',
    warning: 'btn-warning'
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full">
        <h3 className="text-lg font-medium mb-4">{title}</h3>
        <p className="mb-6">{message}</p>
        
        <div className="flex justify-end space-x-3">
          <button
            onClick={onClose}
            disabled={processing}
            className="btn btn-outline"
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            disabled={processing}
            className={`btn ${buttonClasses[confirmColor] || buttonClasses.primary}`}
          >
            {processing ? (
              <>
                <span className="loading loading-spinner"></span>
                Processing...
              </>
            ) : (
              confirmText
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;